export default class UrlsUtil {
  static determineApiBaseUrl = (window: Window): string => {
    return !window.location.hostname.includes('localhost')
      ? `https://${window.location.hostname}`
      : `${process.env.REACT_APP_APIBASEURL}`;
  };
  
  static determineWebSocketUrl = (window: Window): string => {
    const baseUrl = UrlsUtil.determineApiBaseUrl(window);

    // console.log('window.location.protocol', window.location.protocol);
    // console.log('baseUrl', baseUrl.replace(`${window.location.protocol}//`, '').replace(`${window.location.protocol.replace(':', 's:')}//`, ''));

    // @ts-ignore
    return `wss://${baseUrl.replace(`${window.location.protocol}//`, '').replace(`${window.location.protocol.replace(':', 's:')}//`, '')}/ws`;
  };
};